import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/axios";
import Logo from "../components/Logo";

export default function ForgotPassword() {
  const [role,    setRole]    = useState("student");
  const [input,   setInput]   = useState("");
  const [msg,     setMsg]     = useState("");
  const [err,     setErr]     = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const isStudent = role === "student";

  const inp = {
    width:"100%", marginTop:6, padding:"12px 14px", borderRadius:10,
    border:"1px solid #1e293b", background:"#0d0d0d", color:"#f1f5f9",
    fontSize:14, outline:"none", boxSizing:"border-box", fontFamily:"inherit",
  };

  const submit = async e => {
    e.preventDefault();
    setErr(""); setMsg("");

    if (!input.trim()) {
      setErr(isStudent ? "Phone number daalo" : "Email address daalo");
      return;
    }

    setLoading(true);
    try {
      const payload = isStudent
        ? { phone: input.replace(/\D/g, "") }
        : { email: input.trim().toLowerCase() };

      const { data } = await api.post("/auth/forgot-password", payload);

      if (data.reset_token) {
        // Student: token returned directly — redirect to reset page immediately
        nav(`/reset-password/${data.reset_token}`);
      } else {
        setMsg(data.message);
      }
    } catch (e) {
      setErr(e.response?.data?.message || "Something went wrong. Try again.");
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0a", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ background:"#111111", borderRadius:16, border:"1px solid #1e293b", padding:"32px 24px", width:"100%", maxWidth:400 }}>

        <div style={{ textAlign:"center", marginBottom:24 }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:6 }}>
            <Logo size={28} />
          </div>
          <div style={{ fontSize:20, fontWeight:700, color:"#f1f5f9", marginBottom:4 }}>Password Reset</div>
          <div style={{ fontSize:13, color:"#94a3b8" }}>
            {isStudent ? "Phone number se password reset karo" : "Email pe reset link bhejenge"}
          </div>
        </div>

        {/* Role selector */}
        <div style={{ display:"flex", gap:8, marginBottom:22, background:"#0d0d0d", borderRadius:12, padding:4 }}>
          {[
            { key:"student", label:"👨‍👩‍👧 Parent / Student" },
            { key:"teacher", label:"🧑‍🏫 Teacher" },
          ].map(r => (
            <button
              key={r.key}
              type="button"
              onClick={() => { setRole(r.key); setInput(""); setErr(""); setMsg(""); }}
              style={{
                flex:1, padding:"10px 8px", borderRadius:9, border:"none",
                background: role === r.key ? "linear-gradient(135deg,#f97316,#ea580c)" : "transparent",
                color: role === r.key ? "#fff" : "#94a3b8",
                fontSize:13, fontWeight:700, cursor:"pointer", transition:"all .18s",
              }}>
              {r.label}
            </button>
          ))}
        </div>

        {msg ? (
          <>
            <div style={{ color:"#22c55e", fontSize:14, background:"#22c55e15", padding:"14px 16px", borderRadius:10, border:"1px solid #22c55e30", textAlign:"center", lineHeight:1.6 }}>
              ✓ {msg}
            </div>
            <p style={{ textAlign:"center", marginTop:18, fontSize:13, color:"#475569" }}>
              <Link to={`/login?role=${role}`} style={{ color:"#f97316", fontWeight:700, textDecoration:"none" }}>← Login pe jao</Link>
            </p>
          </>
        ) : (
          <form onSubmit={submit} noValidate>

            {isStudent ? (
              <div style={{ marginBottom:20 }}>
                <label style={{ fontSize:13, color:"#94a3b8", fontWeight:500 }}>Registered WhatsApp Number</label>
                <div style={{ position:"relative", marginTop:6 }}>
                  <div style={{ position:"absolute", left:12, top:"50%", transform:"translateY(-50%)", fontSize:13, color:"#94a3b8", fontWeight:600 }}>+91</div>
                  <input
                    type="tel"
                    style={{ ...inp, paddingLeft:44, marginTop:0 }}
                    value={input}
                    onChange={e => { setInput(e.target.value.replace(/\D/g, "").slice(0,10)); setErr(""); }}
                    placeholder="9876500000"
                    maxLength={10}
                  />
                </div>
                <div style={{ fontSize:11, color:"#64748b", marginTop:5, lineHeight:1.6 }}>
                  Wahi number daalo jo register karte waqt diya tha
                </div>
              </div>
            ) : (
              <div style={{ marginBottom:20 }}>
                <label style={{ fontSize:13, color:"#94a3b8", fontWeight:500 }}>Email Address</label>
                <input
                  type="email"
                  style={inp}
                  value={input}
                  onChange={e => { setInput(e.target.value); setErr(""); }}
                  placeholder="you@email.com"
                />
              </div>
            )}

            {err && (
              <div style={{ color:"#ef4444", fontSize:13, marginBottom:14, background:"#ef444415", padding:"10px 14px", borderRadius:8, border:"1px solid #ef444430" }}>
                ⚠ {err}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{ width:"100%", padding:13, background:"linear-gradient(135deg,#f97316,#ea580c)", color:"#fff", border:"none", borderRadius:10, fontSize:15, fontWeight:700, cursor:loading?"not-allowed":"pointer", opacity:loading?0.7:1 }}
            >
              {loading ? "Please wait..." : isStudent ? "Reset Password →" : "Send Reset Link →"}
            </button>
          </form>
        )}

        <p style={{ textAlign:"center", marginTop:18, fontSize:13, color:"#94a3b8" }}>
          <Link to="/login" style={{ color:"#f97316", fontWeight:600, textDecoration:"none" }}>← Back to Login</Link>
        </p>
      </div>
    </div>
  );
}
